/**
 * Suppresses React 18 ReactDOM.render deprecation warning in the browser console.
 * TODO: Remove once EN-82018 is complete and we've migrated to createRoot.
 */
const originalConsoleError = console.error;

console.error = (...args: any[]) => {
  // Filter out the React 18 ReactDOM.render deprecation warning
  if (
    typeof args[0] === 'string' &&
    args[0].includes('Warning: ReactDOM.render is no longer supported in React 18')
  ) {
    return;
  }
  originalConsoleError.apply(console, args);
};
